import React from 'react';
import { motion } from 'framer-motion';
import './Legal.css';

const Eula = () => {
  return (
    <motion.div 
      className="legal-content"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="legal-header">
        <a href="/" className="back-link">← Back to Home</a>
        <h1>End User License Agreement</h1>
        <p className="last-updated">Last updated: May 4, 2026</p>
      </div>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
      >
        <h2>1. License</h2>
        <p>Grind'On Strength & Fitness grants you a limited, personal, non-transferable license to use the Grind On mobile app for fitness training, progress tracking, and community participation.</p>
        <p>You may not copy, modify, reverse engineer, resell, or misuse the app or any part of the service.</p>
      </motion.section>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
      >
        <h2>2. Zero-Tolerance Community Policy</h2>
        <p>By using Grind On, you agree that objectionable content and abusive behavior are not tolerated. This includes harassment, bullying, hate speech, sexually explicit content, threats, graphic violence, spam, impersonation, and content intended to intimidate, humiliate, or harm another person or group.</p>
        <p>We may remove content, suspend access, or terminate accounts that violate this EULA, our Terms, or our Community Guidelines.</p>
      </motion.section>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3 }}
      >
        <h2>3. User-Generated Content</h2>
        <p>You are responsible for the posts, comments, images, profile text, and other content you submit. You must only upload content that you have the right to share and that is appropriate for the Grind On community.</p>
        <p>Grind On may filter, reject, hide, or remove content before or after publication when it appears to violate our safety rules.</p>
      </motion.section>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.4 }}
      >
        <h2>4. Reporting and Blocking</h2>
        <p>The app provides tools to report objectionable posts, comments, and replies. You can also block abusive users. Blocking removes that user's content from your feed immediately and notifies Grind On for review.</p>
        <p>We review objectionable content reports within 24 hours and may remove the content and eject the user who provided the offending content.</p>
      </motion.section>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.5 }}
      >
        <h2>5. Contact</h2>
        <p>For questions about this EULA or to contact us about safety concerns, email <strong>support@grindon.fitness</strong>.</p>
      </motion.section>
    </motion.div>
  );
};

export default Eula;
